import { Component, Input, OnChanges } from '@angular/core';
import { connectConfigure } from 'instantsearch.js/es/connectors';
import { BaseWidget } from './base-widget';

@Component({
  selector: 'app-configure',
  template: '' // headless — no UI
})
export class ConfigureComponent extends BaseWidget<any> implements OnChanges {
  @Input() searchParameters: Record<string, unknown> = {};

  createWidget() {
    return connectConfigure(renderState => {
      this.updateState(renderState);
    })({ searchParameters: this.searchParameters });
  }

  ngOnChanges() {
    if (this.state?.refine) {
      this.state.refine(this.searchParameters);
    }
  }
}
